import type { Lang } from "@ext/markdown/elements/codeBlockLowlight/edit/logic/LowlightLangs";
import CodeBlock from "@ext/markdown/elements/codeBlockLowlight/render/component/CodeBlock";

type Props = {
	"data-language"?: Lang;
	children: string;
};

export const AgentChatCodeBlock = ({ "data-language": language, children }: Props) => (
	<CodeBlock language={language}>{children}</CodeBlock>
);
